import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ImageList, ImageListItem, Typography, Card, CardActions, CardActionArea, CardContent, CardHeader, Button, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { I18n } from 'src/translations/i18n';
import Utils from 'src/utils';
import { SORT_ORDER } from 'src/constants/workTimeService';
import { selectHelpHelpItems } from 'src/store/selectors/help';
import { selectLocale } from 'src/store/selectors/translationSelectors';
import { changeTabIndex, setHelpItemId } from 'src/store/actions/helpActions';
const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%'
    },
    gridTilesContainer: {
        gap: 12
    },
    gridTile: {
        width: '250px!important'
    },
    cardRoot: {
        margin: 1
    },
    cardHeaderRoot: {
        justifyContent: 'center',
        padding: 8
    },
    cardHeaderAvatar: {
        marginRight: 0,
        height: 50
    },
    avatarIcon: {
        width: '50px !important',
        height: '50px !important',
        color: '#FFF'
    },
    cardHeaderContent: {
        display: 'none'
    },
    headerPrimary: {
        backgroundColor: theme.palette.primary.main
    },
    cardContentRoot: {
        paddingBottom: '11px!important',
        paddingTop: '11px!important'
    },
    contentTitle: {
        color: theme.palette.text.color,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    contentDescription: {
        color: theme.palette.subTextColor,
        display: '-webkit-box',
        '-webkit-line-clamp': 4,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: 12,
        height: 68
    },
    button: {
        fontWeight: 600
    },
    link: {
        color: 'inherit!important'
    }
}));
const routesSortFn = Utils.sort.getSortFn(SORT_ORDER.ASC, 'name');
function DashBoardMenu({ routes, gridWidth = 1200, sortAlphabetically = false }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const lang = useSelector(selectLocale);
    const helpItem = useSelector(selectHelpHelpItems);
    const sortedRoutes = useMemo(() => {
        return sortAlphabetically ? routes.sort(routesSortFn) : routes;
    }, [routes, sortAlphabetically]);
    const setHelpItem = (route) => {
        const item = getItemId(route);
        dispatch(changeTabIndex(item.id ? 2 : item.categoryIds[0]));
        dispatch(setHelpItemId(item.id || item.helpItemId));
    };
    const getItemId = (route) => {
        let res = null;
        if (helpItem[lang]) {
            helpItem[lang].some((item) => {
                if (item.pages.includes(route)) {
                    res = item;
                    return true;
                }
                return false;
            });
        }
        return res;
    };
    return (React.createElement("div", { className: classes.container, style: { maxWidth: gridWidth } },
        React.createElement(ImageList, { rowHeight: 240, className: classes.gridTilesContainer }, sortedRoutes.map((route) => (React.createElement(ImageListItem, { className: classes.gridTile, key: route.selectedTabId },
            React.createElement(Card, { classes: { root: classes.cardRoot } },
                React.createElement(CardActionArea, null,
                    React.createElement(Link, { to: route.link },
                        React.createElement(CardHeader, { classes: {
                                root: `${classes.cardHeaderRoot} ${classes.headerPrimary}`,
                                avatar: classes.cardHeaderAvatar,
                                content: classes.cardHeaderContent
                            }, 
                            // @ts-ignore
                            avatar: React.createElement(route.icon, { className: classes.avatarIcon }) }),
                        React.createElement(CardContent, { classes: { root: classes.cardContentRoot } },
                            React.createElement(Typography, { variant: "h6", className: classes.contentTitle }, route.name),
                            React.createElement(Typography, { variant: "body2", className: classes.contentDescription }, route.description)))),
                React.createElement(CardActions, null,
                    React.createElement(Button, { size: "small", color: "primary", className: classes.button },
                        React.createElement(Link, { to: route.link, className: classes.link }, I18n.t('Open'))),
                    React.createElement(Button, { size: "small", color: "primary", className: classes.button, onClick: () => setHelpItem(route.link), disabled: !getItemId(route.link) },
                        React.createElement(Link, { to: "/help", className: classes.link }, I18n.t('MoreInfo')))))))))));
}
export default DashBoardMenu;
